/* eslint-disable no-invalid-this */

import ApiService, { USERS_API_CONTEXT, USERS_API_HOST } from './ApiService';

/**
 * @override
 */
class SubdistributorsService extends ApiService {
    /**
     * constructor
     */
    constructor() {
        super({ baseURL: USERS_API_HOST });
    }

    getSubdistributors = (sort, config) => {
        if (sort.trim() !== '') {
            return this.getList(`${USERS_API_CONTEXT}/subdistributors?$orderby=${sort}`, config);
        } else {
            return this.getList(`${USERS_API_CONTEXT}/subdistributors`, config);
        }
    };
    getSubdistributorByUUId = (uuid, config) => {
        return this.get(`${USERS_API_CONTEXT}/subdistributors/${uuid}`, config);
    }
    getPagination = (url, config) => this.get(`${url}`, config);
    /**
     * Actualizamos la información del subdistributor
     * @override
     */
    update = (uuid, subdist) => {
        return this.put(`${USERS_API_CONTEXT}/subdistributors/${uuid}`, subdist);
    };
    /**
     * @override
     */
    create = subdist => {
        return this.post(`${USERS_API_CONTEXT}/subdistributors`, subdist);
    };

    /**
     * Delete Subdistributor
     * @param {String} uuid Subdistributor id
     * @return {Object} Response of delete operation
     */
    deleteSubdistributorByUUId = uuid => {
        return this.delete(`${USERS_API_CONTEXT}/subdistributors/${uuid}`, {});
    };

}

const subdistributorsService = new SubdistributorsService();

export default subdistributorsService;

